import { createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pantry-select-delete-bar-area" }
const _hoisted_2 = { class: "pantry-select-delete-bar-item" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pantry-select-delete-bar-item-text" }, "捨てた", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "pantry-select-delete-bar-item-text" }, "使い切った", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "pantry-select-delete-bar-delete-text" }, "削除", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "pantry-select-delete-bar" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "pantry-select-delete-bar-item-text-area",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickItem(_ctx.PLATE_DELETE_FOOD_STATUS.THREW_AWAY)))
          }, [
            _hoisted_3
          ]),
          _createVNode("div", {
            class: "pantry-select-delete-bar-item-text-area",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickItem(_ctx.PLATE_DELETE_FOOD_STATUS.USED)))
          }, [
            _hoisted_4
          ]),
          _createVNode("div", {
            class: "pantry-select-delete-bar-item-delete-area",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickItem(_ctx.PLATE_DELETE_FOOD_STATUS.NONE)))
          }, [
            _hoisted_5
          ])
        ])
      ])
    ]),
    _: 1
  }))
}